<div [className]="alertType==='warning' ? 'alert alert-warning' : 'alert alert-error'">
    <i class="fa fa-exclamation-triangle normal-font" aria-hidden="true"></i> {{message}}
</div>